import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VImg,{staticClass:"rounded",attrs:{"src":"/reserve01.png","eager":"","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }